// Wholesale Catalog Matrix
// MOQ tiers mirror the published terms on /pages/wholesale: 10-49u=30% off, 50-99u=40% off,
// 100+u=50% off + custom packaging. Discount is calculated on TOTAL units across all rows.
window.initWholesaleCatalogMatrix = function (sectionId, moneyFormat, isWholesaleCustomer) {
  var root = document.getElementById('pj-wcm-' + sectionId);
  if (!root || root.dataset.wcmInit) return;
  root.dataset.wcmInit = '1';

  var TIERS = [
    { min: 10, max: 49, pct: 0.30, label: '10\u201349 units \u2014 30% off' },
    { min: 50, max: 99, pct: 0.40, label: '50\u201399 units \u2014 40% off \u2605 Most popular' },
    { min: 100, max: Infinity, pct: 0.50, label: '100+ units \u2014 50% off + custom packaging' },
  ];
  function activeTier(units) {
    if (units >= 100) return TIERS[2];
    if (units >= 50) return TIERS[1];
    if (units >= 10) return TIERS[0];
    return null;
  }
  function formatMoney(amount) {
    try {
      if (window.Shopify && window.Shopify.formatMoney && moneyFormat) {
        return window.Shopify.formatMoney(Math.round(amount * 100), moneyFormat);
      }
    } catch (e) {}
    return '\u20b9' + amount.toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  var rows = Array.prototype.slice.call(root.querySelectorAll('.pj-wcm-row'));
  var unitsEl = document.getElementById('pj-wcm-units-' + sectionId);
  var tierEl = document.getElementById('pj-wcm-tier-' + sectionId);
  var subtotalEl = document.getElementById('pj-wcm-subtotal-' + sectionId);
  var submitBtn = document.getElementById('pj-wcm-submit-' + sectionId);
  var clearBtn = document.getElementById('pj-wcm-clear-' + sectionId);
  var clearFilterBtn = document.getElementById('pj-wcm-clearfilter-' + sectionId);
  var legendTiers = root.querySelectorAll('.pj-wcm-moq-tier');
  var searchInput = root.querySelector('.pj-wcm-search');
  var countNumEl = root.querySelector('.pj-wcm-count-num');
  var countdownEl = root.querySelector('.pj-wcm-countdown');
  var treeEl = document.getElementById('pj-wcm-tree-' + sectionId);

  // -- 48h countdown: a visual cue only (no server-side token behind it) --
  var countdownTarget = Date.now() + 48 * 3600 * 1000;
  function tickCountdown() {
    if (!countdownEl) return;
    var rem = Math.max(0, countdownTarget - Date.now());
    countdownEl.textContent = Math.floor(rem / 3600000) + 'h ' + Math.floor((rem % 3600000) / 60000) + 'm';
  }
  tickCountdown();
  setInterval(tickCountdown, 30000);

  // ---------- pricing / totals ----------
  function recalc() {
    var units = 0;
    rows.forEach(function (row) {
      units += parseInt(row.querySelector('.pj-wcm-qty').value, 10) || 0;
    });
    var tier = activeTier(units);
    var subtotal = 0;

    rows.forEach(function (row) {
      var qtyInput = row.querySelector('.pj-wcm-qty');
      var checkbox = row.querySelector('.pj-wcm-check');
      var qty = parseInt(qtyInput.value, 10) || 0;
      var retail = parseFloat(qtyInput.dataset.price) || 0;
      var unitPrice = tier ? retail * (1 - tier.pct) : retail;

      if (isWholesaleCustomer) {
        var whpEl = row.querySelector('.pj-wcm-whp');
        if (whpEl) whpEl.textContent = tier ? formatMoney(unitPrice) : formatMoney(retail);
      }
      row.classList.toggle('pj-wcm-included', qty > 0);
      if (checkbox) checkbox.checked = qty > 0;
      subtotal += unitPrice * qty;
    });

    legendTiers.forEach(function (el) {
      var min = parseInt(el.dataset.min, 10);
      el.classList.toggle('pj-wcm-reached', units >= min);
    });

    if (unitsEl) unitsEl.textContent = units;
    if (tierEl) tierEl.textContent = tier ? tier.label.replace(/^[0-9].*?\u2014\s*/, '') : 'None yet (10+ needed)';
    if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
    if (submitBtn) submitBtn.disabled = units === 0;
  }

  rows.forEach(function (row) {
    var qtyInput = row.querySelector('.pj-wcm-qty');
    var checkbox = row.querySelector('.pj-wcm-check');
    var stepDown = row.querySelector('.pj-wcm-step-down');
    var stepUp = row.querySelector('.pj-wcm-step-up');

    qtyInput.addEventListener('input', recalc);
    stepDown.addEventListener('click', function () {
      var v = (parseInt(qtyInput.value, 10) || 0) - 1;
      qtyInput.value = Math.max(0, v);
      recalc();
    });
    stepUp.addEventListener('click', function () {
      var v = (parseInt(qtyInput.value, 10) || 0) + 1;
      qtyInput.value = v;
      recalc();
    });
    if (checkbox) {
      checkbox.addEventListener('change', function () {
        if (checkbox.checked) {
          if ((parseInt(qtyInput.value, 10) || 0) === 0) qtyInput.value = 10;
        } else {
          qtyInput.value = 0;
        }
        recalc();
      });
    }
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      rows.forEach(function (row) {
        row.querySelector('.pj-wcm-qty').value = 0;
        var notes = row.querySelector('.pj-wcm-notes');
        if (notes) notes.value = '';
      });
      recalc();
    });
  }

  // ---------- taxonomy sidebar (built in JS; matching is best-effort text search
  // against product title/type/tags, since Shape/Size/Style aren't separate
  // structured fields in the catalog yet) ----------
  var SHAPES = ['Round', 'Oval', 'Pear', 'Emerald', 'Cushion', 'Princess', 'Marquise', 'Heart', 'Asscher', 'Radiant', 'Trillion', 'Baguette'];
  var filter = {}; // { material, style, gemGroup, gemStyle, shape, size }
  var expanded = {};

  function matches(row) {
    var hay = ((row.dataset.title || '') + ' ' + (row.dataset.type || '') + ' ' + (row.dataset.tags || '')).toLowerCase();
    if (filter.material && hay.indexOf(filter.material.toLowerCase()) === -1) return false;
    if (filter.style && hay.indexOf(filter.style.toLowerCase()) === -1) return false;
    if (filter.gemGroup && hay.indexOf(filter.gemGroup.toLowerCase()) === -1) return false;
    if (filter.gemStyle && hay.indexOf(filter.gemStyle.toLowerCase()) === -1) return false;
    if (filter.shape && hay.indexOf(filter.shape.toLowerCase()) === -1) return false;
    if (filter.size && hay.indexOf(filter.size.toLowerCase()) === -1) return false;
    var q = (searchInput && searchInput.value || '').toLowerCase();
    if (q) {
      var sku = row.querySelector('.pj-wcm-sku').textContent.toLowerCase();
      if (hay.indexOf(q) === -1 && sku.indexOf(q) === -1) return false;
    }
    return true;
  }

  function applyFilters() {
    var visible = 0;
    rows.forEach(function (row) {
      var show = matches(row);
      row.classList.toggle('pj-wcm-hidden', !show);
      if (show) visible++;
    });
    if (countNumEl) countNumEl.textContent = visible;
  }

  function setFilter(partial) {
    filter = partial || {};
    renderTree();
    applyFilters();
  }

  function jewelleryNode(material) {
    var key = 'mat-' + material;
    var isOpen = expanded[key];
    var activeMat = filter.material === material && !filter.style;
    var types = ['Nepali', 'Fine', 'Plain'];
    var chips = types.map(function (t) {
      var active = filter.material === material && filter.style === t;
      return '<div class="pj-wcm-style-chip' + (active ? ' pj-wcm-active' : '') + '" data-material="' + material + '" data-style="' + t + '">' + t + '</div>';
    }).join('');
    return '<div class="pj-wcm-node">' +
      '<div class="pj-wcm-node-label' + (activeMat ? ' pj-wcm-active' : '') + '" data-material-only="' + material + '">' +
      '<span>' + material + '</span>' +
      '<span class="pj-wcm-chevron' + (isOpen ? ' pj-wcm-open' : '') + '" data-toggle="' + key + '">&#9656;</span>' +
      '</div>' +
      '<div class="pj-wcm-children' + (isOpen ? '' : ' pj-wcm-collapsed') + '"><div class="pj-wcm-style-row">' + chips + '</div></div>' +
      '</div>';
  }

  function gemBlock(title, groupValue) {
    var styles = ['Cut', 'Cabochon', 'Fancy'];
    var chips = styles.map(function (s) {
      var active = filter.gemGroup === groupValue && filter.gemStyle === s;
      return '<div class="pj-wcm-style-chip' + (active ? ' pj-wcm-active' : '') + '" data-gemgroup="' + groupValue + '" data-gemstyle="' + s + '">' + s + '</div>';
    }).join('');
    var activeGroup = filter.gemGroup === groupValue && !filter.gemStyle;
    var shapeOptions = SHAPES.map(function (s) {
      return '<option value="' + s + '"' + (filter.gemGroup === groupValue && filter.shape === s ? ' selected' : '') + '>' + s + '</option>';
    }).join('');
    return '<div class="pj-wcm-node">' +
      '<div class="pj-wcm-node-label' + (activeGroup ? ' pj-wcm-active' : '') + '" data-gemgroup-only="' + groupValue + '"><span>' + title + '</span></div>' +
      '<div class="pj-wcm-gem-block">' +
      '<div class="pj-wcm-style-row">' + chips + '</div>' +
      '<label>Shape</label>' +
      '<select data-shape-for="' + groupValue + '"><option value="">Any</option>' + shapeOptions + '</select>' +
      '<label>Size</label>' +
      '<input type="text" placeholder="e.g. 8x6mm" data-size-for="' + groupValue + '" value="' + (filter.gemGroup === groupValue ? (filter.size || '') : '') + '">' +
      '</div></div>';
  }

  function renderTree() {
    var jKey = 'jewellery';
    var jOpen = expanded[jKey] !== false; // default open
    var html = '<div class="pj-wcm-node">' +
      '<div class="pj-wcm-node-label"><span>Jewellery</span>' +
      '<span class="pj-wcm-chevron' + (jOpen ? ' pj-wcm-open' : '') + '" data-toggle="' + jKey + '">&#9656;</span></div>' +
      '<div class="pj-wcm-children' + (jOpen ? '' : ' pj-wcm-collapsed') + '">' +
      jewelleryNode('Silver') + jewelleryNode('Gold') + jewelleryNode('Victorian') + jewelleryNode('Fashion') +
      '</div></div>';
    html += gemBlock('Precious Gemstones', 'Precious Gemstones');
    html += gemBlock('Semi-Precious Gemstones', 'Semi-Precious Gemstones');
    html += gemBlock('Precious Beads', 'Precious Beads');
    html += gemBlock('Semi-Precious Beads', 'Semi-Precious Beads');
    treeEl.innerHTML = html;
    wireTree();
  }

  function wireTree() {
    treeEl.querySelectorAll('[data-toggle]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        var k = el.dataset.toggle;
        expanded[k] = !(expanded[k] !== false);
        renderTree();
      });
    });
    treeEl.querySelectorAll('[data-material-only]').forEach(function (el) {
      el.addEventListener('click', function () { setFilter({ material: el.dataset.materialOnly }); });
    });
    treeEl.querySelectorAll('.pj-wcm-style-chip[data-material]').forEach(function (el) {
      el.addEventListener('click', function () { setFilter({ material: el.dataset.material, style: el.dataset.style }); });
    });
    treeEl.querySelectorAll('[data-gemgroup-only]').forEach(function (el) {
      el.addEventListener('click', function () { setFilter({ gemGroup: el.dataset.gemgroupOnly }); });
    });
    treeEl.querySelectorAll('.pj-wcm-style-chip[data-gemgroup]').forEach(function (el) {
      el.addEventListener('click', function () { setFilter({ gemGroup: el.dataset.gemgroup, gemStyle: el.dataset.gemstyle }); });
    });
    treeEl.querySelectorAll('[data-shape-for]').forEach(function (el) {
      el.addEventListener('change', function () { setFilter({ gemGroup: el.dataset.shapeFor, shape: el.value }); });
    });
    treeEl.querySelectorAll('[data-size-for]').forEach(function (el) {
      el.addEventListener('change', function () { setFilter({ gemGroup: el.dataset.sizeFor, size: el.value }); });
    });
  }

  if (clearFilterBtn) {
    clearFilterBtn.addEventListener('click', function () { setFilter({}); });
  }
  if (searchInput) searchInput.addEventListener('input', applyFilters);

  renderTree();
  applyFilters();

  // ---------- submit: real cart + existing enquiry form ----------
  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      var items = [];
      rows.forEach(function (row) {
        var qtyInput = row.querySelector('.pj-wcm-qty');
        var qty = parseInt(qtyInput.value, 10) || 0;
        if (qty > 0) items.push({ id: qtyInput.dataset.variantId, quantity: qty });
      });
      if (!items.length) return;

      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding to cart\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) { if (!r.ok) throw new Error('Cart add failed'); return r.json(); })
        .then(function () { window.location.href = '/pages/wholesale#contact_form'; })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit for Bulk Quote';
          alert('Something went wrong adding these items to your cart. Please try again.');
        });
    });
  }

  recalc();
};
